import React, { FC } from 'react';
import useTranslation from '../../../hooks/useTranslation';
import CustomInput from '../../../common/CustomInput';

const ProjectNameInput: FC = () => {
  const t = useTranslation();
  return (
    <CustomInput
      dataTestID={'project-name'}
      name={'projectName'}
      required
      label={t('projects.properties.projectName')}
    />
  );
};

export default ProjectNameInput;
